import { render, staticRenderFns } from "./MovementRouteLessonSectionEdit.vue?vue&type=template&id=6f32605b"
import script from "./MovementRouteLessonSectionEdit.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonSectionEdit.vue?vue&type=script&lang=js"
import style0 from "./MovementRouteLessonSectionEdit.vue?vue&type=style&index=0&id=6f32605b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports